export default __webpack_public_path__ + "static/media/request.800b11ca.png";